<template>
    <div class="updateTime">
        <vs-row class="mb-4" vs-align="center" v-for="(content, index) of scheduling_caps" :key="index">
            <vs-col vs-w="3">
                <div class="pl-2 pr-2 flex items-center">
                    <vs-icon
                        size="small"
                        color="primary"
                        v-bind="$iconData('icon-calendar', 'fi-rr-calendar-days')"
                    />
                    <div class="ml-2">{{ $t(`calendar.daysOfWeek.${content.day}`)}}</div>
                </div>
            </vs-col>
            <vs-col vs-w="7">
                <div class="pl-2 pr-2 flex items-center">
                    <vs-input
                        size="small"
                        :disabled="!content.is_active"
                        class="inputx"
                        type="time"
                        v-model="content.cc_work_start"
                    />
                    <div class="ml-4 mr-4">:</div>
                    <vs-input
                        size="small"
                        :disabled="!content.is_active"
                        class="inputx" type="time"
                        v-model="content.cc_work_end"
                    />
                </div>
            </vs-col>
            <vs-col vs-w="2">
                <div class="pl-2 pr-2 flex justify-end">
                    <vs-switch
                        color="success"
                        v-model="content.is_active"
                        icon-pack="feather"
                        vs-icon-off="icon-x"
                        vs-icon-on="icon-check"
                    />
                </div>
            </vs-col>
        </vs-row>

        <vs-row>
            <vs-col vs-w="12">
                <div class="p-2 text-right">
                    <vs-button @click="submit" button="submit" ref="btn">{{ $t('buttons.Save') }}</vs-button>
                </div>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import ErrorHandler from "@/utils/errorHandler"
import send from "@/utils/fetch"
import EventBus from "@/store/eventBus";

export default {
    props: ['popupData', 'popupType', 'popupButton'],

    data() {
        return {
            scheduling_caps: [
                {day: 'Monday', cc_work_end: '23:59', cc_work_start: '00:01', is_active: true, leads: 0, set: 0, remainder: 0},
                {day: 'Tuesday', cc_work_end: '23:59', cc_work_start: '00:01', is_active: true, leads: 0, set: 0, remainder: 0},
                {day: 'Wednesday', cc_work_end: '23:59', cc_work_start: '00:01', is_active: true, leads: 0, set: 0, remainder: 0},
                {day: 'Thursday', cc_work_end: '23:59', cc_work_start: '00:01', is_active: true, leads: 0, set: 0, remainder: 0},
                {day: 'Friday', cc_work_end: '23:59', cc_work_start: '00:01', is_active: true, leads: 0, set: 0, remainder: 0},
                {day: 'Saturday', cc_work_end: '23:59', cc_work_start: '00:01', is_active: false, leads: 0, set: 0, remainder: 0},
                {day: 'Sunday', cc_work_end: '23:59', cc_work_start: '00:01', is_active: false, leads: 0, set: 0, remainder: 0}
            ],
        }
    },

    methods: {
        copy(data) {
            return JSON.parse(JSON.stringify(data))
        },

        ucFirst(str) {
            if (!str) return str
            return str[0].toUpperCase() + str.slice(1)
        },

        async submit() {
            try {
                const scheduling_caps = this.scheduling_caps.map(item => {
                    return {
                        cc_work_end: item.cc_work_end,
                        cc_work_start: item.cc_work_start,
                        id: item.id,
                        day: item.day,
                        is_active: item.is_active
                    }
                })

                await send(this.$url.cap.cap, 'PATCH', {data: {scheduling_caps}})

                if (this.popupData.is === 'teams') {
                    EventBus.$emit(`resetInt_${this.popupData.team_id}`)
                } else {
                    EventBus.$emit('getCaps')
                }

                EventBus.$emit('emitPopupEvent', {type: 'close'})
            } catch (e) {
                new ErrorHandler(e).send
            }
        }
    },

    mounted() {
        try {
            const scheduling_caps = this.copy(this.popupData.scheduling_caps || this.popupData.caps)
            if (scheduling_caps && Array.isArray(scheduling_caps) && scheduling_caps.length) {
                this.scheduling_caps = scheduling_caps.map(item => {
                    item.day = this.ucFirst(item.day)
                    return item
                })
            }

            this.$store.commit('UPDATE_LOADER_STATE', false)
        } catch (e) {
            this.$store.commit('UPDATE_LOADER_STATE_SET_ERROR', true)
            new ErrorHandler(e).send
        }
    }
}
</script>
